import { render, staticRenderFns } from "./doughnut.vue?vue&type=template&id=68476d3e&"
import script from "./doughnut.vue?vue&type=script&lang=js&"
export * from "./doughnut.vue?vue&type=script&lang=js&"
import style0 from "./doughnut.vue?vue&type=style&index=0&id=68476d3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports